import React, { createContext } from 'react';
import WorksheetRow from '../../../../models/WorksheetRow';

export const WorksheetContext = createContext<{
  clientFacingNamesAreVisible?: boolean;
  userIsEditingASpaceName?: boolean;
  isRenderingForExport?: boolean;
  isWorksheetOpenForDownload?: boolean;
  showDecimals?: boolean;
  activeRowIdentifier?: string;
  changeRow?: (
    row: WorksheetRow,
    options?: {
      name?: string;
      isNameUpdate?: boolean;
      isCustomSpaceType?: boolean;
    }
  ) => void;
  changeChildRow?: (
    row: WorksheetRow,
    options: { name?: string; isNameUpdate?: boolean }
  ) => void;
  onRowNameFocus?: () => void;
  onRowNameBlur?: () => void;
  renameSpaceType?: (
    row: WorksheetRow,
    newName: string,
    isCustomSpaceType?: boolean
  ) => boolean;
  collapsed?: { [id: string]: boolean };
  setCollapsedRow?: (
    row: WorksheetRow,
    isTotalProgramParentRow: boolean
  ) => void;
  newRowRef?: React.RefObject<HTMLDivElement>;
  newRowId?: string;
}>({
  clientFacingNamesAreVisible: false,
  isRenderingForExport: false,
  isWorksheetOpenForDownload: false,
  showDecimals: false,
  activeRowIdentifier: '',
  changeRow: null,
  changeChildRow: null,
  onRowNameFocus: null,
  onRowNameBlur: null,
  renameSpaceType: null,
  collapsed: null,
  setCollapsedRow: null,
  newRowRef: null,
  newRowId: null,
});
